import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  collapsed: false,
  showModal: false,
  collapseIcon: true,
  fromSideBar: true,
  navbarTabs: [],
  activeTab: "",
};

export const layoutSlice = createSlice({
  name: "layout",
  initialState,
  reducers: {
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    setCollapsed: (state, action) => {
      if (action.payload || action.payload === false) {
        state.collapsed = action.payload;
      } else {
        state.collapsed = !state.collapsed;
      }
    },
    setShowModal: (state, { payload }) => {
      state.showModal = payload;
    },
    closeModal: (state) => {
      state.showModal = false;
    },
    setCollapseIcon: (state) => {
      state.collapseIcon = !state.collapseIcon;
    },
    setNavbarTabs: (state, action) => {
      // Remove the tab if it already exists
      const newTabs = state.navbarTabs.filter((tab) => tab?.name !== action.payload?.name);

      // If adding this new tab would exceed 10, remove the first tab
      if (newTabs.length >= 10) {
        newTabs.shift(); // remove the oldest tab (index 0)
      }
      // Add the new tab
      state.navbarTabs = [...newTabs, action.payload];

      // Set as active tab
      state.activeTab = action.payload;
      state.fromSideBar = true;
    },
    removeNavbarTab: (state, action) => {
      state.navbarTabs = state.navbarTabs.filter((tab) => tab?.name !== action.payload);
    },
    removeInactiveNavbarTab: (state, action) => {
      state.navbarTabs = state.navbarTabs.filter((tab) => tab?.name === action.payload);
    },
    removeAllNavbarTab: (state, action) => {
      state.navbarTabs = [];
    },
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
      state.fromSideBar = false;
    },
  },
});
const { actions, reducer } = layoutSlice;
export const {
  goToPage,
  setCollapsed,
  setShowModal,
  closeModal,
  setCollapseIcon,
  setNavbarTabs,
  removeNavbarTab,
  removeInactiveNavbarTab,
  removeAllNavbarTab,
  setActiveTab,
} = actions;
export default reducer;
